import { Component, OnInit } from '@angular/core';
import { Contact } from 'src/app/contacts/shared/contact.model';
import { ContactTypeService } from 'src/app/contacts/contact-type/shared/contact-type.service';
import { UserService } from 'src/app/users/shared/user.service';
import { SelectItem } from 'primeng/api';
import { ProfileAdvancedSearchParams } from '../../profile-advanced-search-params.model';
import { ProfileService } from 'src/app/profiles/shared/profile.service';
import { NotificationService } from 'src/app/shared';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'wl-create-contact-search-action',
  templateUrl: './create-contact-search-action.component.html',
  styleUrls: ['./create-contact-search-action.component.less'],
    standalone: false
})
export class CreateContactSearchActionComponent implements OnInit {
  public contactModel: Contact;
  public contactTypes = [];
  public users = [];
  public valid = false;
  constructor(
    private _contactTypeService: ContactTypeService,
    private _profileService: ProfileService,
    private _notifyService: NotificationService
  ) {
    this.contactModel = { ContacteeUserNum: 0, ContactDate: new Date() } as Contact;
  }

  ngOnInit(): void {
    this._contactTypeService.getContactTypes({ PageSize: 0, PageNumber: 0 }).then((data) => {
      this.contactTypes = data.Result.map<SelectItem>((x) => {
        return { label: x.Descr, value: x.ContactType };
      });
    });
  }

  onFieldChange() {
    this.valid =
      !!this.contactModel.ContacteeUserNum &&
      !!this.contactModel.ContactType &&
      !!this.contactModel.Subject &&
      !!this.contactModel.Descr &&
      !!this.contactModel.ContactDate;
  }

  createProfilesContact(profileIds: number[]) {
    this._profileService
      .createProfilesContact(profileIds, this.contactModel)
      .then(() => {
        this._notifyService.translateSuccess('common.success');
      })
      .catch((error) => {
        this._notifyService.httpError(error);
      });
  }

  massCreateProfilesContact(searchParams: ProfileAdvancedSearchParams) {
    this._profileService.createProfilesContactAdvanced(searchParams, this.contactModel).then(() => {
      this._notifyService.translateSuccess('profiles.search.set-status-success');
    });
  }
}
